import { useWindowSize } from "usehooks-ts";
const MOBILE_CUTOFF = 768;
export default function useDevice() {
    // SSR-safe: return desktop as default when window is not available
    const { width } = typeof window !== 'undefined' ? useWindowSize() : { width: 1024 };
    const isMobile = width < MOBILE_CUTOFF;
    return {
        isMobile,
        isComputer: !isMobile,
    };
}
